// extracted by mini-css-extract-plugin
export var externalLink = "_aa-0";
export var internalLinkLabel = "_aa-1";